import { FC, useMemo } from 'react';

import { PanelLayout } from '../PanelLayout';
import { TestMetadata } from '../types';

export interface DualPanelLayoutProps {
  /** Primary is set to have auto width by default */
  inverse?: boolean;
  /** Custom class name for layout */
  className?: string;
  /** Test data IDs for layout */
  testMetadata?: TestMetadata;
  /** AreaMap */
  areaMap?: {
    primary: string;
    secondary: string;
  };
}

const DualPanelLayout: FC<DualPanelLayoutProps> = ({
  inverse = false,
  children,
  areaMap = {
    primary: 'primary',
    secondary: 'secondary',
  },
  ...otherProps
}) => {
  const layout = useMemo(
    () => ({
      slim: {
        columns: ['1fr'],
        rows: ['1fr', 'auto'],
        areas: [[areaMap.primary], [areaMap.secondary]],
      },
      small: {
        columns: inverse ? ['1fr', 'auto'] : ['auto', '1fr'],
        rows: ['1fr'],
        areas: inverse
          ? [[areaMap.primary, areaMap.secondary]]
          : [[areaMap.secondary, areaMap.primary]],
      },
    }),
    [inverse, areaMap],
  );

  return (
    <PanelLayout {...layout} {...otherProps}>
      {children}
    </PanelLayout>
  );
};

export default DualPanelLayout;
